import { ROUTES } from "../../components/Routes/routes";
import { PAGE_KEYS } from "./page-key";
import { ROLES } from "./role-details";
const {
    RACK_FEATURES,
    RACK_PRICING,
    BID_FEATURES,
    SETUP,
} = ROUTES;

// Tab-level permissions
export const TAB_PERMISSIONS = {
    // Allocation component tabs
    [RACK_FEATURES.allocation]: {
        [PAGE_KEYS.DAILY_ALLOCATION]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS],
        [PAGE_KEYS.ALLOCATION_SETUP]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.OPERATIONS],
    },
    // Benchmark Entry tabs
    [RACK_PRICING.benchmarkEntry]: {
        [PAGE_KEYS.BENCHMARK_ENTRY_PLATTS]: [ROLES.SYSTEM_ADMIN],
        [PAGE_KEYS.BENCHMARK_ENTRY_ARGUS]: [ROLES.SYSTEM_ADMIN],
    },
    // Wet Move tabs
    [RACK_PRICING.wetMove]: {
        [PAGE_KEYS.WET_MOVE_GAS]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS],
        [PAGE_KEYS.WET_MOVE_DIESEL]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER, ROLES.SALES_REP, ROLES.OPERATIONS],
        [PAGE_KEYS.WET_MOVE_CONFIGURATION]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
    },
    // Terminal Group tabs
    [RACK_FEATURES.terminalGroup]: {
        [PAGE_KEYS.TERMINAL_GROUP]: [ROLES.SYSTEM_ADMIN],
        [PAGE_KEYS.TERMINAL_GROUP_MAP]: [ROLES.SYSTEM_ADMIN],
    },
    // Formula tabs
    [RACK_FEATURES.formula]: {
        [PAGE_KEYS.RACK_CONTRACT_FORMULA]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.RACK_CONTRACT_FORMULA_LOW_MAP]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.RACK_CONTRACT_VARIABLES]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
    },
    // Formula OPIS tabs
    [RACK_FEATURES.formulaOPIS]: {
        [PAGE_KEYS.FORMULA_OPIS]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.FORMULA_OPIS_CITY_CONTRACT_GROUP]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.FORMULA_OPIS_CITY_CONTRACT_GROUP_MAP]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
    },
    // Bid Terminal Group tabs
    [BID_FEATURES.bidTerminalGroup]: {
        [PAGE_KEYS.BID_TERMINAL_GROUP]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.BID_TERMINAL_GROUP_CONTRACTS]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
    },
    // Customers tabs
    [SETUP.customer]: {
        [PAGE_KEYS.CUSTOMER]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.CUSTOMER_BID_SELECTION]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.CUSTOMER_DTN_TERMINALS]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.CUSTOMER_RELATIONSHIPS]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
    },
    // Dtn City tabs
    [SETUP.dtnCity]: {
        [PAGE_KEYS.DTN_CITY]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.DTN_CITY_TERMINAL]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
    },
    // FastRacks tabs
    [SETUP.fastRacks]: {
        [PAGE_KEYS.FAST_RACKS_SETUP]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.FAST_RACKS_FREIGHT]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.FAST_RACKS_TAX]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
    },
    // Fuel Suppliers tabs
    [SETUP.fuelSupplier]: {
        [PAGE_KEYS.FUEL_SUPPLIER]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.FUEL_SUPPLIER_EXCLUSIONS]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
    },
    // Settings tabs
    [SETUP.settings]: {
        [PAGE_KEYS.SETTINGS]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.SETTINGS_ALLOWED]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
    },
    // Time Setup tabs
    [SETUP.timeSetup]: {
        [PAGE_KEYS.TIME_SETUP_FRAME]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.TIME_SETUP_ZONE]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
    },
    // Verify Benchmark tabs
    [SETUP.verifyBenchmark]: {
        [PAGE_KEYS.VERIFY_BENCHMARK_ARGUS]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.VERIFY_BENCHMARK_DTN]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.VERIFY_BENCHMARK_PLATTS]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
        [PAGE_KEYS.VERIFY_BENCHMARK_RACK_VERIFY]: [ROLES.SYSTEM_ADMIN, ROLES.MANAGER],
    },
};
